import {Alert, useOpenModal} from '@/components/Modal'
import {chooseFiles} from '@/script/file.mjs'
import {useAiContext} from './AiContext.mjs'

export const useAttach = () => {
    const openModal = useOpenModal()
    const ai = useAiContext()
    const isAttachDisabled = ai.maxFileCount <= ai.draft.files.length

    const pickDir = async () => {
        const files = []
        const dirHandler = await window.showDirectoryPicker()

        const getFiles = async dirHandler => {
            for await (const e of dirHandler.values()) {
                if ('directory' === e.kind) {
                    await getFiles(e)
                }
                else if ('file' === e.kind) {
                    if (! e.name.startsWith('.')) {
                        const f = await e.getFile()
                        files.push(f)
                    }
                }

                if (ai.maxFileCount <= ai.draft.files.length) {
                    return
                }
            }
        }

        await getFiles(dirHandler)

        ai.setDraft(d => ({
            ...d,
            files: [...d.files, ...files]
        }))
    }

    const pickFile = async () => {
        const files = await chooseFiles({multiple: 1 < ai.maxFileCount})

        if (! files) {
            return
        }

        if (ai.maxFileCount < files.length + ai.draft.files.length) {
            await openModal(
                <Alert type="warn">
                    超出最大允许文件数：{ai.maxFileCount}
                </Alert>
            )
        }

        ai.setDraft(d => ({
            ...d,

            files: [
                ...d.files,
                ...files.slice(0, ai.maxFileCount - d.files.length)
            ],
        }))
    }

    return {isAttachDisabled, pickDir, pickFile}
}
